import React from 'react';
import PropTypes from 'prop-types';

import round from 'lodash/round';

import { connect } from 'react-redux';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { UNIT_DOLLARS, UNIT_PERCENT } from 'bundles/backoffice/vouchers/helpers/transaction_side_details';
import {
  calculatesCommissionRate,
  calculatesGrossCommissionAmount,
  calculatesGrossCommissionPercent,
} from 'bundles/apex/deals/lease_terms/helpers';
import { changeDealTransactionSide } from 'bundles/apex/deals/form/store/deal/actions';
import * as commissionModes from 'components/lease_structure/form/commission_modes';

export function TransactionSideTotals({ changeDealTransactionSide, className, deal, transactionSide }) {
  const details = deal.transactionSideDetails.find(details => details.transactionSide === transactionSide);
  const showCommissionRate = deal.commissionMode === commissionModes.RATE_PER_SPACE_SIZE_UNIT_PER_MONTH
    || deal.commissionMode === commissionModes.RATE_PER_SPACE_SIZE_UNIT_PER_YEAR;
  let grossPercent = details.grossPercent || 0;

  if (details.grossUnit === UNIT_DOLLARS) {
    grossPercent = round(grossPercent, 2);
  }

  const handleChange = (change, grossUnit) => {
    const changes = { ...change, grossUnit };
    changeDealTransactionSide(deal, changes, transactionSide, grossUnit === UNIT_DOLLARS);
  };

  return <div className={className}>
    {!showCommissionRate && (
      <ManagedFormGroup
        disabled={calculatesGrossCommissionPercent(deal)}
        label="Gross Percent"
        name="grossPercent"
        required
        type="number"
        value={grossPercent}
        onChange={change => handleChange(change, UNIT_PERCENT)}
      />
    )}
    {showCommissionRate && (
      <ManagedFormGroup
        disabled={calculatesCommissionRate(deal)}
        label="Commission Rate"
        name="grossRate"
        required
        type="currency"
        value={details.grossRate}
        onChange={change => handleChange(change, details.grossUnit)}
      />
    )}
    <ManagedFormGroup
      className="mb-3"
      disabled={calculatesGrossCommissionAmount(deal)}
      label="Gross Amount"
      name="grossAmount"
      required
      type="currency"
      value={details.grossAmount}
      onChange={change => handleChange(change, UNIT_DOLLARS)}
    />
  </div>;
}

TransactionSideTotals.propTypes = {
  changeDealTransactionSide: PropTypes.func.isRequired,
  className: PropTypes.string,
  deal: PropTypes.shape({
    transactionSideDetails: PropTypes.arrayOf(PropTypes.shape({
      grossAmount: PropTypes.number.isRequired,
      grossPercent: PropTypes.number.isRequired,
      transactionSide: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  changeDealTransactionSide,
};

export default connect(null, mapDispatchToProps)(TransactionSideTotals);
